module.exports = __webpack_public_path__ + "img/openings.bb8ade3f.svg";